module.exports = __webpack_public_path__ + "img/mind_icon_number_2.5fd2f9a5.png";